<template>

  <div>

  <el-alert show-icon type="info1" title="Please Note" :description="'Any ' + typeInv + ' items with a started date later than today, will not show until due date.'" />

  <xolas-table
    :table-ref="tableRef"
    :title="type + ' ' + typeInv + ' Items'"
    :url="sharerId ? urlSharer : urlSite"
    :show-search="false"
    :fields="fields">

    <template v-if="!noAdd" #actions>
      <site-invoice-action v-bind="addProps" />
    </template>

    <template #rowactions="props">

      <div class="si-row-actions" v-if="isManager('finance') && (!props.rowData.type.includes('Asset') && !props.rowData.type.includes('Fees'))">

        <site-invoice-action v-if="props.rowData.type.includes('Site') && !sharerId"  type="primary" :row-data="props.rowData" :site-id="siteData.id" :sharer-id="sharerId" :type="addProps.type" :table-ref="addProps.tableRef" />
        <site-invoice-action v-if="props.rowData.type.includes('Sharer') && sharerId"  type="primary" :row-data="props.rowData" :site-id="siteData.id" :sharer-id="sharerId" :type="addProps.type" :table-ref="addProps.tableRef" />

        <el-button v-if="props.rowData.type.includes('Site V.O.') && !sharerId" type="danger" size="mini" circle icon="fa fa-trash" @click="deleteInv(props.rowData)" />
        <el-button v-if="props.rowData.type.includes('Sharer V.O.') && sharerId" type="danger" size="mini" circle icon="fa fa-trash" @click="deleteInv(props.rowData)" />
        <el-button v-if="props.rowData.type === 'Sharer Item' && sharerId" type="danger" size="mini" circle icon="fa fa-trash" @click="deleteInv(props.rowData)" />
        <el-button v-if="props.rowData.type === 'Site Item' && !sharerId" type="danger" size="mini" circle icon="fa fa-trash"  @click="deleteInv(props.rowData)" />

      </div>

    </template>

  </xolas-table>

  </div>

</template>

<script>

import SiteMixins from '@/mixins/SiteMixins'
import SiteInvoiceAction from '@/components/actions/SiteInvoiceAction'

export default {

  mixins: [SiteMixins],

  components: {
    SiteInvoiceAction
  },

  props: {
    siteData: {
      type: Object,
      required: true
    },

    sharerId: {
      type: Number,
      default: null
    },

    isVo: {
      type: Boolean,
      default: false
    }

  },


  methods: {
    editInv (row) {
      alert('edit: ' + row)
    },

    deleteInv (row) {

      this.deleteItem(this, row.id, this.deleteUrl,
        this.type + ' ' + this.typeInv + ' Item' + (row.description ? ': ' + row.description : ''),
        this.onDelete)

    },

    onDelete (response) {
      this.$events.emit(this.tableRef + '-refresh-table')
    }
  },

/*
  watch: {
    sharerId: function (id) {
      this.sh
    }
  },
*/

  data () {
    return {
      type: this.sharerId ? 'Sharer' : 'Site',
      typeInv: this.isVo ? 'V.O.' : 'Invoice',
      tableRef: (this.sharerId ? 'sharer' : 'site') + (this.isVo ? '-vo' : '') + '-invoice-table',

      localSite: this.siteData,
      addProps: {
        siteId: this.siteData.id,
        sharerId: this.sharerId,
        type: (this.sharerId ? 'Sharer' : 'Site') + (this.isVo ? ' V.O.' : '') + ' Item',
        tableRef: (this.sharerId ? 'sharer' : 'site') + (this.isVo ? '-vo' : '') + '-invoice-table'
      },

      noAdd: !this.isManager('finance|management'),
      urlSite: 'finance/invoice/site/' + this.siteData.id + (this.isVo ? '/vo' : ''),
      urlSharer: 'finance/invoice/sharer/' + this.siteData.id + '/' + this.sharerId + (this.isVo ? '/vo' : ''),
      deleteUrl: 'finance/invoice/' + (this.sharerId ? 'sharers' : 'sites'),

      // Column widths tuned to match the legacy vuetable-2 layout (XOL-232).
      // This 14-column table lives in the ~880px sharer drawer; el-table's 80px
      // default min-column-width forced every column to 80 (overflow + wrapping),
      // so the numeric columns get explicit tight widths and the text columns
      // flex via min-width. Paired with the compact/header-wrap ::v-deep style
      // below (scoped to SiteInvoice).
      fields: [
        {
          name: '__sequence',
          title: '#',
          width: 24
        },
        {
          name: 'type',
          title: 'Type',
          minWidth: 104,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'billingStart',
          title: 'Start',
          width: 86,
          callback: this.formatDate,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'billingPeriod',
          title: 'Frequency',
          width: 78,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'description',
          title: 'Desc.',
          minWidth: 184
        },
        {
          name: 'quantity',
          title: 'Qty.',
          width: 30,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'amount',
          title: 'Amount',
          width: 58,
          callback: this.formatNumber,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'discount',
          title: 'Disc.',
          width: 36,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'totalDiscount',
          title: 'Total Disc.',
          width: 50,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'tax',
          title: 'Tax',
          width: 52,
          callback: this.formatNumber,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'subTotal',
          title: 'Sub-Total',
          width: 58,
          callback: this.formatNumber,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'total',
          title: 'TOTAL',
          width: 58,
          callback: this.formatNumber,
          titleClass: 'text-primary',
          dataClass: 'text-primary'
        },
        {
          name: 'lastBilling',
          title: 'Last Bill',
          width: 48,
          callback: this.formatDate,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: '__slot:rowactions',
          width: 64
        }
      ]
    }
  }

}
</script>

<style scoped>
/* XOL-232: the sharer/site invoice items table is 14 columns wide and lives in
   the ~880px finance drawer. el-table's default cell padding + forced single-line
   headers (global XolasTable rule) make the columns overflow and wrap, where the
   legacy vuetable laid them out compactly with wrapped headers. Compact the
   padding and allow header wrap so the layout matches dev. Scoped to SiteInvoice
   via ::v-deep — other migrated tables keep their default spacing. */
/* Near-zero horizontal cell padding mirrors the legacy vuetable (its <td> used
   `padding: 12px 0`), which is what lets the money/date columns hold values like
   "2200.00" / "30 Nov 2020" on one line in this narrow drawer. */
::v-deep .el-table th .cell,
::v-deep .el-table td .cell {
  padding-left: 0;
  padding-right: 0;
}

/* Let dense headers ("Total Disc.", "Sub-Total", "Last Bill") wrap to two lines
   like dev, instead of the global single-line rule forcing wide columns. */
::v-deep .el-table th .cell {
  white-space: normal;
  line-height: 1.25;
}

/* Match dev's td padding (12px 0) exactly → 49px single-line rows. */
::v-deep .el-table td,
::v-deep .el-table th.is-leaf {
  padding-top: 12px;
  padding-bottom: 12px;
}

/* Per-row edit/delete cluster: flex with a gap so the circle buttons never
   overlap (the old el-row/el-col grid squeezed them into one cell). */
::v-deep .si-row-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

/* Element UI adds margin-left to adjacent buttons; the flex gap handles spacing,
   so zero it out to keep the cluster centred. */
::v-deep .si-row-actions .el-button,
::v-deep .si-row-actions .el-button + .el-button {
  margin-left: 0;
}
</style>
